import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Alert
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FixedWingAugmentedCrew = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Augmented Crew (Para 7)</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            Augmented crew operation limits based on D7J-J4-Fixed Wing.pdf Para 7.1.1, 7.1.2, and 7.1.3.
          </Typography>
        </Alert>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>Para 7.1.1: 3 Crew Operation</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time"
              type="number"
              value={baseline.maxFlightTime3Crew}
              onChange={(e) => handleChange('maxFlightTime3Crew', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 15, step: 0.5 }}
              helperText="Para 7.1.1: 12 hrs (13 hrs for GA)"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time (GA)"
              type="number"
              value={baseline.maxFlightTime3CrewGA}
              onChange={(e) => handleChange('maxFlightTime3CrewGA', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 15, step: 0.5 }}
              helperText="Para 7.1.1: 13 hrs for General Aviation"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Landings"
              type="number"
              value={baseline.maxLandings3Crew}
              onChange={(e) => handleChange('maxLandings3Crew', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 5, step: 1 }}
              helperText="Para 7.1.1: 2 landings"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (Bunk)"
              type="number"
              value={baseline.maxFDP3CrewBunk}
              onChange={(e) => handleChange('maxFDP3CrewBunk', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 20, step: 0.5 }}
              helperText="Para 7.1.1: 17:00"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (Isolated Rest Seat)"
              type="number"
              value={baseline.maxFDP3CrewIsolatedRest}
              onChange={(e) => handleChange('maxFDP3CrewIsolatedRest', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 20, step: 0.5 }}
              helperText="Para 7.1.1: 16:00"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (Basic Rest Seat)"
              type="number"
              value={baseline.maxFDP3CrewBasicRest}
              onChange={(e) => handleChange('maxFDP3CrewBasicRest', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 20, step: 0.5 }}
              helperText="Para 7.1.1: 15:00"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>Para 7.1.2: 4 Crew Operation</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Max Flight Time"
              type="number"
              value={baseline.maxFlightTime4Crew}
              onChange={(e) => handleChange('maxFlightTime4Crew', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 15, step: 0.5 }}
              helperText="Para 7.1.2: 14 hrs"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Max FDP (Bunk)"
              type="number"
              value={baseline.maxFDP4CrewBunk}
              onChange={(e) => handleChange('maxFDP4CrewBunk', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 20, step: 0.5 }}
              helperText="Para 7.1.2: 18:00"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Max FDP (Isolated Rest Seat)"
              type="number"
              value={baseline.maxFDP4CrewIsolatedRest}
              onChange={(e) => handleChange('maxFDP4CrewIsolatedRest', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 20, step: 0.5 }}
              helperText="Para 7.1.2: 17:00"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Max Landings"
              type="number"
              value={baseline.maxLandings4Crew}
              onChange={(e) => handleChange('maxLandings4Crew', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 5, step: 1 }}
              helperText="Para 7.1.2: 1 landing"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>Para 7.1.3: 4 Crew ULR Operation</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time"
              type="number"
              value={baseline.maxFlightTime4CrewULR}
              onChange={(e) => handleChange('maxFlightTime4CrewULR', parseFloat(e.target.value))}
              inputProps={{ min: 14, max: 20, step: 0.1 }}
              helperText="Para 7.1.3: > 14 hrs (DGCA approval required)"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (Bunk)"
              type="number"
              value={baseline.maxFDP4CrewULRBunk}
              onChange={(e) => handleChange('maxFDP4CrewULRBunk', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 20, step: 0.5 }}
              helperText="Para 7.1.3: 19:00"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Landings"
              type="number"
              value={baseline.maxLandings4CrewULR}
              onChange={(e) => handleChange('maxLandings4CrewULR', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 5, step: 1 }}
              helperText="Para 7.1.3: 1 landing"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FixedWingAugmentedCrew;
